export const environment = {
  production: false,
  apiBaseUrl: 'https://iris.ellipse-online.com/csp/apibna',
  publicBaseUrl: 'https://iris.ellipse-online.com/csp/apibna-public'
};
